export default __webpack_public_path__ + "static/media/Rotate_Left_Stage1.338c13c2.svg";